<template>
  <v-toolbar v-if="menu.link" class="white" dense>
    <v-spacer></v-spacer>
    <v-toolbar-title v-html="menu.title" class="ml-9" />
    <v-spacer></v-spacer>
    <v-btn :to="menu.link" icon>
      <v-icon>{{ menu.icon }}</v-icon>
    </v-btn>
  </v-toolbar>
  <v-toolbar v-else class="white" dense>
    <v-btn :to="menu.back" icon>
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>
    <v-spacer></v-spacer>
    <v-toolbar-title v-html="menu.title" class="mr-9" />
    <v-spacer></v-spacer>
  </v-toolbar>
</template>
<script>
import axios from 'axios'

export default {
  name: 'TopBar',
  props: ['menu'],
}
</script>
